import { fetchOneWebviewBackgroundHeader } from '../../../requests'

export const funcGetOneHeaderImage = async (resource, params) => {
  const [, data] = await fetchOneWebviewBackgroundHeader(params.id)
  return { data }
}
